import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useQuery } from 'react-query';
import customerEndpointsQueryKeys from './customerEndpointsQueryKeys';

export const useCustomerEndpointsListQuery = (options = {} as any) => {
    const { authToken, currentAccountId } = useAuthSelector();
    const accountId = (options.accountId ?? currentAccountId) as string;
    const baseQueryKey = customerEndpointsQueryKeys.list(accountId);
    const queryKey = options.params ? [...baseQueryKey, options.params] : baseQueryKey;
    const query = useQuery(queryKey, async () => sdk.customer_endpoints.list(accountId, { ...options, authToken }), {});

    return {
        ...query,
        queryKey,
    };
};

export default useCustomerEndpointsListQuery;
